import { all } from 'redux-saga/effects'

import auth from './auth'
import alerts from './alerts'
import database from './database'
import exportSaga from './export'
import history from './history'
import references from './references'
import schedule from './schedule'

export default function* rootSaga() {
    yield all([
        auth(),
        schedule(),
        references(),
        exportSaga(),
        alerts(),
        database(),
        history(),
    ])
}
